<template>
  <div class="flex-col gap-y-md">
    <dd-skeleton-header-card v-for="i in packageCount" :key="i" :action-count="3" v-if="true">
    </dd-skeleton-header-card>
    <dd-skeleton-header-card  v-if="true">
    </dd-skeleton-header-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SkeletonResults.vue",
  computed: {
    ...mapState(`$_policy_page`, {
      packageCount: 'packageCount',
      policyCount: 'policyCount',
    })
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
